module.exports = __webpack_public_path__ + "img/portada_txangurro.89bf6451.jpg";